import { Component, OnDestroy, OnInit } from '@angular/core';
import * as PageHeaderActions from '../../../../store/page-header/page-header.actions';
import { Store } from '@ngrx/store';
import { PageHeaderStateInterface } from '../../../../store/page-header/page-header.model';
import { Subscription } from 'rxjs';
import { IotDeviceManagementPortalAppState } from '../../../../store/iotDeviceManagementPortalApp.reducer';

@Component({
  selector: 'app-filter-visibility-button',
  templateUrl: './filter-visibility-button.component.html',
})
export class FilterVisibilityButtonComponent implements OnInit, OnDestroy {
  public isFilterBarVisible = true;
  private readonly subscriptions: Subscription[] = [];

  constructor(private readonly store: Store<IotDeviceManagementPortalAppState>) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.store.select('pageHeaderStore').subscribe((state: PageHeaderStateInterface) => {
        this.isFilterBarVisible = state.isFilterBarVisible;
      }),
    );
  }

  public filterVisibilityButtonClicked(): void {
    this.store.dispatch(new PageHeaderActions.UpdateFilterBarVisibility(!this.isFilterBarVisible));
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((value: Subscription) => {
      value.unsubscribe();
    });
  }
}
